<template>
  <div v-if="topic.parent">
    <router-link class="topic-link" :to="isRTL ? topicLink : parentLink">{{ isRTL ? topicName : parentName }}</router-link>
    <span class="topic-link">{{ isRTL ? '&laquo;' : '&raquo;' }}</span>
    <router-link class="topic-link" :to="isRTL ? parentLink : topicLink">{{ isRTL ? parentName : topicName }}</router-link>
  </div>
</template>
<script>
export default {
  props: ['topic'],
  computed: {
    topicName: function() {
      return this.topic.name || this.topic.label;
    },
    topicLink: function() {
      return '/topic/' + this.topic.parent.url_key + '/' + this.topic.url_key;
    },
    parentName: function() {
      return this.topic.parent.name || this.topic.parent.label;
    },
    parentLink: function() {
      return '/topic/' + this.topic.parent.url_key;
    },
  },
};
</script>
